// extracted by mini-css-extract-plugin
export var typingIndicator = "_qy-0";